<template>
	<div class="add-alias-ip-range-dialog-container">
		<el-dialog :title="$t('subnet.text.addIpAliasRange')" :visible.sync="visible" @close="doClose"
			class="cps-dialog-icon-line-height"
			:close-on-click-modal="false"
			>
			<el-form ref="form" :model="form" label-width="140px">
				<!--目标网络接口名称-->
				<el-form-item :label="$t('eip.text.targetInternetAccessName') | withColon" >
					<el-radio-group v-model="selectTargetInternetAccessName" @change="changeTargetInternetAccessName">
						<el-radio-button v-for="item in targetInternetAccessNames" :key="item.label" :label="item.label">
							{{item.value}}
						</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<!--私有网络-->
				<el-form-item :label="$t('privateNetwork.privateNetwork') | withColon">
					<span>{{vpcName | maybeEmpty}}</span>
				</el-form-item>
				<!--VPC CIDR-->
				<el-form-item :label="$t('privateNetwork.vpcCidr') | withColon" prop="name">
					<span>{{vpcCidr | maybeEmpty}}</span>
				</el-form-item>
				<el-form-item :label="$t('privateNetwork.vpcIpv6Cidr') | withColon" prop="name">
					<span>{{vpcIpv6Cidr | maybeEmpty}}</span>
				</el-form-item>
				<!--主网口别名IP范围-->
				<add-alias-ip-range 
					:visible="addIpRangeVisible"
					:subnetDetailData="detailData"
					:aliasIpRestNumber="aliasIpRestNumber"
					:aliasIpv6RestNumber="aliasIpv6RestNumber"
					:selectTargetInternetAccessName="selectTargetInternetAccessName"
					type="list"
					ref="addAliasIpRange"
					v-model="aliasIpDialogData">
				</add-alias-ip-range>
				<!--辅网口别名IP范围-->
				<add-alias-ip-range 
					:visible="addExtendsionIpRangeVisible"
					:subnetDetailData="detailData"
					:aliasIpRestNumber="aliasIpRestNumber"
					:aliasIpv6RestNumber="aliasIpv6RestNumber"
					:selectTargetInternetAccessName="selectTargetInternetAccessName"
					type="list"
					ref="extensionAddAliasIpRange"
					v-model="extensionAliasIpDialogData">
				</add-alias-ip-range>
				<!--添加别名IP范围-->
				<el-form-item class="add-alias-ip">
					<el-tooltip :content="$t('subnet.help.only10IpAliasForOneInstance')" placement="right"
						:disabled="!addIconDisabled">
						<a @click="addAliasIpRangeRow"
							 class="add-alias-ip-a-disabled"
							 :class="{'cps-dropdown-disabled': addIconDisabled }">
							<i class="jc-icon-plus"></i>
							{{$t('subnet.text.addIpAliasRange')}}
						</a>
					</el-tooltip>
					<span class="ml10">
						{{$t('subnet.help.moreAliasIpAvailablePart1')}}
					</span>
					<span class="highlight-font-color">{{aliasIpRestNumber}}</span>
					<span>
						{{$t('subnet.help.moreAliasIpAvailablePart2')}}
					</span>
					<span v-if="vpcIpv6Cidr">
						{{$t('subnet.help.moreAliasIpAvailablePart3')}}
					</span>
					<span class="highlight-font-color" v-if="vpcIpv6Cidr">{{aliasIpv6RestNumber}}</span>
					<span v-if="vpcIpv6Cidr">
						{{$t('subnet.help.moreAliasIpAvailablePart2')}}
					</span>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="doClose">
					{{ $t('detail.text.cancel') }}
				</el-button>
				<el-button @click="doConfirm" type="primary" :disabled="confirmDisabled">
					{{$t('detail.text.sure')}}
				</el-button>
			</span>
		</el-dialog>
		<alias-ip-add-result
			:result-dialog-visible="addAliasIpRangeResultDialogVisible"
			:success-data-list="successResultData"
			:fail-data-list="errorResultData">
		</alias-ip-add-result>
	</div>

</template>

<script>
import { ValidOrErrorConstant,TargetNetworkInterfaceName } from '@/common/Constants';
import AddAliasIpRange from '@/components/common/addAliasIpRange/AddAliasIpRange';
import AliasIpAddResult from '@/components/common/aliasIpAddResult/AliasIpAddResult';

export default {
	components: {
		AddAliasIpRange,
		AliasIpAddResult
	},
	props: {
		// 实例详情数据
		detailData: {
			type: Object
		},
		// 是否显示
		dialogVisible: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return {
			form: {
				name: '',
				cidr: ''
			},
			formTag: {
				name: ValidOrErrorConstant.VALID
			},
			visible: this.dialogVisible,
			selectTargetInternetAccessName: '1',
			//能够添加的最大的别名IP数
			maxAliasIpCount: 50,
			// 添加成功的数据列表
			successResultData: [],
			// 添加失败的数据列表
			errorResultData: [],
			// 添加的主网口别名IP表格数据
			aliasIpDialogData: [],
			// 添加的辅网口别名IP表格数据
			extensionAliasIpDialogData: [],
			addIpRangeVisible:false,
			addExtendsionIpRangeVisible:false,
		};
	},
	computed: {
		//目标网络接口名称
		targetInternetAccessNames() {
			let interfaceMode = this.detailData.interfaceMode;
			if (interfaceMode === 'bond') {
				return [
					{
						label: '1',
						value: this.$t('eip.text.singleInternetAccessChiefName')
					}
				];
			} else if (interfaceMode === 'dual') {
				return [
					{
						label: '1',
						value: this.$t('eip.text.chiefInternetAccessName')
					},
					{
						label: '2',
						value: this.$t('eip.text.subInternetAccessName')
					}
				];
			}
		},
		vpcCidr() {
			if (this.selectTargetInternetAccessName === '1') {
				return this.detailData.vpcCidr
			} else if (this.selectTargetInternetAccessName === '2') {
			 	return this.detailData.extensionVpcCidr
			}
		},
		vpcIpv6Cidr() {
			if (this.selectTargetInternetAccessName === '1') {
				return this.detailData.vpcIpv6Cidr
			} else if (this.selectTargetInternetAccessName === '2') {
			 	return this.detailData.extensionVpcIpv6Cidr
			}
		},
		vpcName() {
			if (this.selectTargetInternetAccessName === '1') {
				return this.detailData.vpcName
			} else if (this.selectTargetInternetAccessName === '2') {

			 	return this.detailData.extensionVpcName
			}
		},

		ValidOrErrorConstant: () => ValidOrErrorConstant,
		// 添加提示弹框是否可见
		addAliasIpRangeResultDialogVisible() {
			return this.errorResultData.length >= 1;
		},
		// 添加别名IP范围禁用(已添加的别名IP范围个数和表格中的数据和为50或超过50)
		addIconDisabled() {
			if(this.aliasIpRestNumber === 0 && this.aliasIpv6RestNumber === 0) {
				return true
			} else {
				return false
			}
		},
		// 还可添加多少个别名IP
		aliasIpRestNumber() {
			let cidrCount = 0;
			for(var i=0;i<this.aliasIpDialogData.length-1;i++) {
				if(this.aliasIpDialogData[i].cidr!=='') {
					cidrCount ++;
					
				}
			};
			
			let extensionCidrCount = 0;
			for(var i=0;i<this.extensionAliasIpDialogData.length-1;i++) {
				if(this.extensionAliasIpDialogData[i].cidr!=='') {
					extensionCidrCount ++;
				}
			};
			let iCount = 0;
			if (this.selectTargetInternetAccessName === '1') {
				if(this.$refs.addAliasIpRange && this.$refs.addAliasIpRange.isRowNotSaved){
					iCount = this.maxAliasIpCount - this.detailData.isCheckAliasIpTotal - cidrCount;
				}else { 
					if(this.aliasIpDialogData.length>0) {
						if(this.aliasIpDialogData && this.aliasIpDialogData[this.aliasIpDialogData.length-1].cidr) {
							iCount = this.maxAliasIpCount - this.detailData.isCheckAliasIpTotal - cidrCount-1;
						}else{
							iCount = this.maxAliasIpCount - this.detailData.isCheckAliasIpTotal - cidrCount;
						}
					}else{
						iCount = this.maxAliasIpCount - this.detailData.isCheckAliasIpTotal - cidrCount;
						}
				}				
			} else if (this.selectTargetInternetAccessName === '2') {
				if(this.$refs.extensionAddAliasIpRange && this.$refs.extensionAddAliasIpRange.isRowNotSaved){
					iCount = this.maxAliasIpCount - this.detailData.extensionAliasIpTotal - extensionCidrCount;
				}else {
					if(this.extensionAliasIpDialogData.length>0) {
						if(this.extensionAliasIpDialogData && this.extensionAliasIpDialogData[this.extensionAliasIpDialogData.length-1].cidr) {
							iCount = this.maxAliasIpCount - this.detailData.extensionAliasIpTotal - extensionCidrCount-1;
						}else{
							iCount = this.maxAliasIpCount - this.detailData.extensionAliasIpTotal - extensionCidrCount;
						}
					}else{
						iCount = this.maxAliasIpCount - this.detailData.extensionAliasIpTotal - extensionCidrCount;
					}
				}
			}
			return iCount > 0 ? iCount : 0
		},
		aliasIpv6RestNumber() {
			let cidrCount = 0;
			for(var i=0;i<this.aliasIpDialogData.length-1;i++) {
				if(this.aliasIpDialogData[i].ipv6Cidr!=='') {
					cidrCount ++;
				}
			};
			let extensionCidrCount = 0;
			for(var i=0;i<this.extensionAliasIpDialogData.length-1;i++) {
				if(this.extensionAliasIpDialogData[i].ipv6Cidr!=='') {
					extensionCidrCount ++;
				}
			};
			let iCount = 0;
			if (this.selectTargetInternetAccessName === '1') {				
				if(this.$refs.addAliasIpRange && this.$refs.addAliasIpRange.isRowNotSaved){
					iCount = this.maxAliasIpCount - this.detailData.isCheckIpv6AliasIpTotal - cidrCount;
				}else {
					if(this.aliasIpDialogData.length>0) {
						if(this.aliasIpDialogData && this.aliasIpDialogData[this.aliasIpDialogData.length-1].ipv6Cidr) {
							iCount = this.maxAliasIpCount - this.detailData.isCheckIpv6AliasIpTotal - cidrCount-1;
						}else{
							iCount = this.maxAliasIpCount - this.detailData.isCheckIpv6AliasIpTotal - cidrCount;
						}
					}else{
						iCount = this.maxAliasIpCount - this.detailData.isCheckIpv6AliasIpTotal - cidrCount;
					}	
				}				
			} else if (this.selectTargetInternetAccessName === '2') {
				if(this.$refs.extensionAddAliasIpRange && this.$refs.extensionAddAliasIpRange.isRowNotSaved){
					iCount = this.maxAliasIpCount - this.detailData.extensionIpv6AliasIpTotal  - extensionCidrCount;
				}else {	
					if(this.extensionAliasIpDialogData.length>0) {
						if(this.extensionAliasIpDialogData && this.extensionAliasIpDialogData[this.extensionAliasIpDialogData.length-1].ipv6Cidr) {
							iCount = this.maxAliasIpCount - this.detailData.extensionIpv6AliasIpTotal  - extensionCidrCount-1;
						}else{
							iCount = this.maxAliasIpCount - this.detailData.extensionIpv6AliasIpTotal  - extensionCidrCount;
						}
					}else{
						iCount = this.maxAliasIpCount - this.detailData.extensionIpv6AliasIpTotal  - extensionCidrCount;
					}
					
				}
			}
			return iCount > 0 ? iCount : 0
		},
		// 确定添加按钮是否置灰
		confirmDisabled() {
			if (this.selectTargetInternetAccessName === '1') {
				for (const item of this.aliasIpDialogData) {
					if (item.isEditing === true) {
						return true
					}
				}
			} else if (this.selectTargetInternetAccessName === '2') {
			 	for (const item of this.extensionAliasIpDialogData) {
					if (item.isEditing === true) {
						return true
					}
				}
			}
			
		}
	},
	watch: {
		dialogVisible(newVal) {
			this.selectTargetInternetAccessName = '1';
			this.addIpRangeVisible = true;
			this.addExtendsionIpRangeVisible = false;
			this.visible = newVal;
			if (newVal === false) {
				this.selectTargetInternetAccessName = '2';
			} else {
				this.selectTargetInternetAccessName = '1';
			}
			this.aliasIpDialogData = [];
			this.extensionAliasIpDialogData = [];			
		}
	},
	methods: {
		// 切换目标网络接口名称
		changeTargetInternetAccessName() {	
			if(this.selectTargetInternetAccessName==="1") {
				this.addIpRangeVisible = true
				this.addExtendsionIpRangeVisible = false
			}else if(this.selectTargetInternetAccessName==="2") {
				this.addExtendsionIpRangeVisible = true
				this.addIpRangeVisible = false
			}
		},
		// 添加一行
		addAliasIpRangeRow() {
			if (this.aliasIpRestNumber === 0 && this.aliasIpv6RestNumber === 0 ) {
				return
			} else {
				if (this.selectTargetInternetAccessName === '1') {
					this.$refs.addAliasIpRange.addOneRow();
				} else if (this.selectTargetInternetAccessName === '2') {
				 	this.$refs.extensionAddAliasIpRange.addOneRow();
				}
			}
		},
		// 取消
		doClose() {
			this.addIpRangeVisible = false;
			this.addExtendsionIpRangeVisible = false;
			this.$emit('update:dialogVisible', false);
		},
		// 确定
		doConfirm() {
			this.addAliasIps();
			this.doClose();
		},
		// 添加别名IP
		addAliasIps() {
			const tempParam = [];
			if (this.selectTargetInternetAccessName === '1') {				
				for (const item of this.aliasIpDialogData) {
					if (item.ipv6Cidr) {
						tempParam.push({
							id: item.subnetObject.sid,
							scope: 'ipv6',
							cidr: item.subnetObject.ipv6Str+':'+item.ipv6Cidr+'/'+item.lastIpv6Cidr
						})
					} else {
						tempParam.push({
							id: item.subnetObject.sid,
							scope: 'ipv4',
							cidr: item.cidr
						})
					}
					
				}
			} else if(this.selectTargetInternetAccessName === '2') {
				for (const item of this.extensionAliasIpDialogData) {
					if (item.ipv6Cidr) {
						tempParam.push({
							id: item.subnetObject.sid,
							scope: 'ipv6',
							cidr: item.subnetObject.ipv6Str+':'+item.ipv6Cidr+'/'+item.lastIpv6Cidr
						})
					} else {
						tempParam.push({
							id: item.subnetObject.sid,
							scope: 'ipv4',
							cidr: item.cidr
						})
					}
				}
			}

			const params = Object.assign({ aliasIps: tempParam }, {
				region: this.detailData.region,
				instanceId: this.detailData.instanceId,
				subnetId: this.selectTargetInternetAccessName === '1' ? this.detailData.subnetId : this.detailData.extensionSubnetId,
				clientToken: Normal.getClientToken(),
			});
			Ajax.put('/api/cps/aliasIps', params, {
				headers: {
					'Content-Type': 'application/json'
				}
			}).then((res) => {
				this.successResultData = res.data.successList;
				this.errorResultData = res.data.errorList;
				// 如果全部添加成功,右上角成功提示
				if (res.data.errorList.length === 0) {
					this.$message.success(this.$t('subnet.text.addSuccess'));
				}
				// 操作成功刷新列表或者详情
				this.$emit('refreshDetailData');
			})
			.catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
			.finally(() => {
				this.doClose();
			});
		},
	}
};
</script>

<style lang="scss">
	.add-alias-ip-range-dialog-container{
		.el-dialog{
			width: 850px
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/addAliasIpRangeDialog/AddAliasIpRangeDialog.vue